import { create } from 'zustand';

interface InviteUserFormState {
  isFormOpen: boolean;
  setIsFormOpen: (isFormOpen: boolean) => void;
}

export const useInviteUserFormStore = create<InviteUserFormState>((set) => ({
  isFormOpen: false,
  setIsFormOpen: (isFormOpen: boolean) => set(() => ({ isFormOpen })),
}));
